(function ($) {

 $(document).ready(function ($) {
   $(".collage-card.only_image").click(function() {
      window.location = $(this).find("a").attr("href");
      return false;
    });
   $(".collage-card .image-slider").click(function() {
      window.location = $(this).find("a").attr("href");
      return false;
    });
    $(".multicolumn-card").click(function() {
      window.location = $(this).find("a").attr("href");
      return false;
    });
 })

})(jQuery);


const productRecommendationsSection = document.querySelector('.product-recommendations');
if(productRecommendationsSection) {
  const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
}
    